import React, { useState } from 'react';
import './ProfessionalInternship.css';

const SOURCE_OPTIONS = [
  'Friend / Family Referral',
  'School / College Recommendation',
  'Google Search',
  'Social Media (Instagram / Facebook)',
  'YouTube',
  'LinkedIn',
  'WhatsApp',
  'Newspaper / Magazine',
  'Event / Hackathon',
  'ibots Website',
  'Other',
];

const errStyle = { color: '#e8394d', fontSize: '11px', marginTop: '4px' };

function ProfessionalInternship({ onClose }) {
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    fullName: '', phone: '', email: '', institution: '',
    programme: '', startDate: '', engagementType: '',
    domain: '', customDomain: '', profile: '',
    source: '', customSource: '', resume: null,
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleFileChange = (e) => setFormData({ ...formData, resume: e.target.files[0] });

  const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject('');
    reader.readAsDataURL(file);
  });

  const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = 'Full name is required';
    if (!formData.phone) newErrors.phone = 'Phone number is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.institution) newErrors.institution = 'Institution is required';
    if (!formData.engagementType) newErrors.engagementType = 'Please select engagement type';
    if (!formData.domain) newErrors.domain = 'Please select a domain';
    if (!formData.source) newErrors.source = 'Please tell us how you heard about ibots';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setTimeout(() => {
        const firstError = document.querySelector('.error-field');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
      return;
    }

    let resumeBase64 = '';
    let resumeName = '';
    if (formData.resume) {
      try { resumeBase64 = await toBase64(formData.resume); resumeName = formData.resume.name; }
      catch (e) { console.log('File read error:', e); }
    }

    try {
      await fetch('http://localhost:5000/api/enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formType: 'professional-internship',
          fullName: formData.fullName,
          phone: formData.phone,
          email: formData.email,
          institution: formData.institution,
          programme: formData.programme,
          startDate: formData.startDate,
          engagementType: formData.engagementType,
          domain: formData.domain,
          customDomain: formData.customDomain,
          profile: formData.profile,
          source: formData.source === 'Other' ? formData.customSource : formData.source,
        }),
      });
      try {
        await fetch('http://localhost:5000/api/centre', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name:           formData.fullName,
            type:           'College',
            phone:          formData.phone,
            email:          formData.email,
            institution:    formData.institution,
            grade:          formData.programme || '',
            mode:           'Offline',
            formType:       'Professional Internship',
            engagementType: ({
              'hardware': 'Hardware Domain',
              'software': 'Software Domain',
              'combined': 'Combined Hardware + Software',
            }[formData.engagementType] || formData.engagementType || ''),
            domain: formData.domain === 'other' ? formData.customDomain : ({
              'pcb':         'PCB Design & Circuit Development',
              'robotics':    'Robotics & Mechatronics Systems',
              'drone':       'Drone Assembly & Flight Systems',
              'prototyping': 'Product Prototyping & Hardware Testing',
              'stm32':       'STM32 & Embedded Board Integration',
              'firmware':    'Embedded Firmware Development (C / HAL)',
              'iot':         'IoT, Cloud & Dashboard Integration',
              'ai':          'AI & Computer Vision Projects',
              'app':         'App & Web Interface for IoT Products',
              'ros':         'Python / ROS for Automation Projects',
            }[formData.domain] || formData.domain || ''),
            startDate:      formData.startDate || '',
            profile:        formData.profile || '',
            resumeName:     resumeName || '',
            resumeUploaded: resumeBase64 ? 'Yes' : 'No',
            source:         formData.source === 'Other' ? formData.customSource : formData.source,
          }),
        });
      } catch (err) {
        console.log('Dashboard error:', err);
      }
      setSubmitted(true);
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
  };

  if (submitted) {
    return (
      <div className="pi__overlay" onClick={onClose}>
        <div className="pi__box" onClick={(e) => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center', gap: '16px' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#dcfce7', color: '#16a34a', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900 }}>✓</div>
          <h2 style={{ color: '#0d2e6e', fontWeight: 900, margin: 0 }}>Thank You for Reaching Out to ibots!</h2>
          <p style={{ color: '#64748b', margin: 0, maxWidth: '300px', lineHeight: '1.6' }}>We have received your professional internship application. Our team will review your profile and get in touch with you within <strong>48 hours</strong>.</p>
          <button className="pi__submit" onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div className="pi__overlay" onClick={onClose}>
      <div className="pi__box" onClick={(e) => e.stopPropagation()}>

        <button className="pi__close" onClick={onClose}>✕ Close</button>
        <h2 className="pi__title">Professional Internship — Domain Details</h2>
        <p className="pi__subtitle">Join the ibots engineering team. Choose your domain and contribute to live client projects.</p>

        <div className="pi__stats">
          <div className="pi__stat"><p className="pi__stat-value">Stipend</p><p className="pi__stat-note">Performance-Based</p></div>
          <div className="pi__stat"><p className="pi__stat-value">1–3 Months</p><p className="pi__stat-note">Duration</p></div>
          <div className="pi__stat"><p className="pi__stat-value">Live Projects</p><p className="pi__stat-note">Real Client Work</p></div>
          <div className="pi__stat"><p className="pi__stat-value">Certificate</p><p className="pi__stat-note">+ Experience Letter</p></div>
        </div>

        <div className="pi__domains">
          <div className="pi__domain-card">
            <p className="pi__domain-title">HARDWARE DOMAIN</p>
            <ul className="pi__domain-list">
              {['PCB Design & Circuit Development','Robotics & Mechatronics Systems','Drone Assembly & Flight Systems','Product Prototyping & Hardware Testing','STM32 & Embedded Board Integration'].map((item, i) => (
                <li key={i}><span className="pi__check">✓</span> {item}</li>
              ))}
            </ul>
            <p className="pi__domain-ideal">Ideal for ECE / EEE / Mechatronics students with hands-on hardware interest</p>
          </div>
          <div className="pi__domain-card pi__domain-card--software">
            <p className="pi__domain-title pi__domain-title--blue">SOFTWARE DOMAIN</p>
            <ul className="pi__domain-list">
              {['Embedded Firmware Development (C / HAL)','IoT, Cloud & Dashboard Integration','AI & Computer Vision Projects','App & Web Interface for IoT Products','Python / ROS for Automation Projects'].map((item, i) => (
                <li key={i}><span className="pi__check">✓</span> {item}</li>
              ))}
            </ul>
            <p className="pi__domain-ideal pi__domain-ideal--blue">Ideal for CSE / IT / ECE students with a programming or AI focus</p>
          </div>
        </div>

        <div className="pi__warning">
          <span className="pi__warning-icon">⚠️</span>
          <p>Positions are limited and filled through a structured selection process. Our team will review your profile and contact you within <strong>48 hours</strong>.</p>
        </div>

        <h3 className="pi__form-title">Apply — Professional Internship at ibots</h3>
        <p className="pi__form-subtitle">Selected candidates work alongside the ibots engineering team on live client projects. Positions are limited and filled through a structured selection process.</p>

        <div className="pi__form">
          <div className="pi__row">
            <div className="pi__group">
              <label className="pi__label">Full Name *</label>
              <input type="text" name="fullName" value={formData.fullName}
                onChange={handleChange} placeholder="Enter your full name" className="pi__input" />
              {errors.fullName && <p style={errStyle} className="error-field">{errors.fullName}</p>}
            </div>
            <div className="pi__group">
              <label className="pi__label">Phone *</label>
              <input type="text" name="phone" value={formData.phone}
                onChange={handleChange} placeholder="+91 XXXXX XXXXX" className="pi__input" />
              {errors.phone && <p style={errStyle} className="error-field">{errors.phone}</p>}
            </div>
          </div>

          <div className="pi__row">
            <div className="pi__group">
              <label className="pi__label">Email *</label>
              <input type="email" name="email" value={formData.email}
                onChange={handleChange} placeholder="you@example.com" className="pi__input" />
              {errors.email && <p style={errStyle}>{errors.email}</p>}
            </div>
            <div className="pi__group">
              <label className="pi__label">Institution *</label>
              <input type="text" name="institution" value={formData.institution}
                onChange={handleChange} placeholder="College / University name" className="pi__input" />
              {errors.institution && <p style={errStyle}>{errors.institution}</p>}
            </div>
          </div>

          <div className="pi__row">
            <div className="pi__group">
              <label className="pi__label">Programme & Year</label>
              <input type="text" name="programme" value={formData.programme}
                onChange={handleChange} placeholder="e.g. B.E. ECE, 3rd Year" className="pi__input" />
            </div>
            <div className="pi__group">
              <label className="pi__label">Preferred Start Date</label>
              <input type="text" name="startDate" value={formData.startDate}
                onChange={handleChange} placeholder="e.g. June 2025" className="pi__input" />
            </div>
          </div>

          <div className="pi__group pi__group--full">
            <label className="pi__label">Engagement Type *</label>
            <select name="engagementType" value={formData.engagementType}
              onChange={handleChange} className="pi__input pi__select">
              <option value="">Select engagement type...</option>
              <option value="hardware">Hardware Domain Internship</option>
              <option value="software">Software Domain Internship</option>
              <option value="combined">Combined Hardware + Software</option>
            </select>
            {errors.engagementType && <p style={errStyle} className="error-field">{errors.engagementType}</p>}
          </div>

          <div className="pi__group pi__group--full">
            <label className="pi__label">Select Domain *</label>
            <select name="domain" value={formData.domain}
              onChange={handleChange} className="pi__input pi__select">
              <option value="">Choose your domain...</option>
              <option value="pcb">PCB Design & Circuit Development</option>
              <option value="robotics">Robotics & Mechatronics Systems</option>
              <option value="drone">Drone Assembly & Flight Systems</option>
              <option value="prototyping">Product Prototyping & Hardware Testing</option>
              <option value="stm32">STM32 & Embedded Board Integration</option>
              <option value="firmware">Embedded Firmware Development (C / HAL)</option>
              <option value="iot">IoT, Cloud & Dashboard Integration</option>
              <option value="ai">AI & Computer Vision Projects</option>
              <option value="app">App & Web Interface for IoT Products</option>
              <option value="ros">Python / ROS for Automation Projects</option>
              <option value="other">Other (specify below)</option>
            </select>
            {errors.domain && <p style={errStyle}>{errors.domain}</p>}
            {formData.domain === 'other' && (
              <input type="text" name="customDomain" value={formData.customDomain}
                onChange={handleChange} placeholder="Describe your domain of interest..."
                className="pi__input pi__input--mt" />
            )}
          </div>

          <div className="pi__group pi__group--full">
            <label className="pi__label">Profile & Skills</label>
            <textarea name="profile" value={formData.profile} onChange={handleChange}
              placeholder="Describe your technical skills, projects, and why you are a strong candidate..."
              className="pi__input pi__textarea" />
          </div>

          <div className="pi__group pi__group--full">
            <label className="pi__label">Upload Resume <span className="pi__file-note">(PDF only · Max 5 MB)</span></label>
            <label className="pi__upload-box">
              <input type="file" accept=".pdf" onChange={handleFileChange} className="pi__file-input" />
              <div className="pi__upload-content">
                <span className="pi__upload-icon">📄</span>
                <p className="pi__upload-text">{formData.resume ? formData.resume.name : 'Click to upload your Resume'}</p>
                <p className="pi__upload-note">PDF format only · Maximum file size: 5 MB</p>
              </div>
            </label>
          </div>

          <div className="pi__group pi__group--full">
            <label className="pi__label">How did you hear about ibots? *</label>
            <select name="source" value={formData.source}
              onChange={handleChange} className="pi__input pi__select">
              <option value="">Select...</option>
              {SOURCE_OPTIONS.map((s) => (<option key={s} value={s}>{s}</option>))}
            </select>
            {errors.source && <p style={errStyle} className="error-field">{errors.source}</p>}
            {formData.source === 'Other' && (
              <input type="text" name="customSource" value={formData.customSource}
                onChange={handleChange} placeholder="Please tell us how you found us..."
                className="pi__input" style={{ marginTop: '8px' }} />
            )}
          </div>

          <button className="pi__submit" onClick={handleSubmit}>
            Submit Application →
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProfessionalInternship;
